import { render, staticRenderFns } from "./batchInputPeople.vue?vue&type=template&id=61a84254&scoped=true&"
import script from "./batchInputPeople.vue?vue&type=script&lang=js&"
export * from "./batchInputPeople.vue?vue&type=script&lang=js&"
import style0 from "./batchInputPeople.vue?vue&type=style&index=0&id=61a84254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a84254",
  null
  
)

export default component.exports